import { getAllRoles, getAllTeams, getRoleLabel, getTeamLabel, Role, Team, trackAnalytics } from '@puffin/app-frame-api';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

interface ConfigurationFieldsProps {
  team?: Team;
  role?: Role;
  onTeamChange: (team: Team) => void;
  onRoleChange: (role: Role) => void;
}

export const ConfigurationFields = ({ team, role, onTeamChange, onRoleChange }: ConfigurationFieldsProps) => (
  <>
    <FormControl required fullWidth>
      <InputLabel id="team-label">Team</InputLabel>
      <Select
        labelId="team-label"
        label="Team"
        value={team ?? ''}
        onChange={(event) => {
          onTeamChange(event.target.value);
          trackAnalytics('APPLICATION_CONFIGURATION_TEAM_CHANGED', { team: event.target.value });
        }}
      >
        {getAllTeams().map((team) => (
          <MenuItem key={team} value={team}>
            {getTeamLabel(team)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
    <FormControl required fullWidth>
      <InputLabel id="role-label">Role</InputLabel>
      <Select
        labelId="role-label"
        label="Role"
        value={role ?? ''}
        onChange={(event) => {
          onRoleChange(event.target.value);
          trackAnalytics('APPLICATION_CONFIGURATION_ROLE_CHANGED', { role: event.target.value });
        }}
      >
        {getAllRoles().map((role) => (
          <MenuItem key={role} value={role}>
            {getRoleLabel(role)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </>
);
